module.exports = __webpack_public_path__ + "img/sample1-view.jpg";